<template>
  <div class="footer-components">
    <header class="footer">
      <p>Copyright ©️ 2019 株式会社三和</p>
        <a href="https://www.heartful-sanwa.co.jp/privacypolicy" target="_blank" rel="noopener">
          プライバシーポリシー
        </a>
    </header>
    <div class="return_top">
      <a href="#top_position" v-smooth-scroll>
        <img src="../assets/img/common/icon/return_top.svg" alt="return top" width="20px">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    // msg: String
  }
}
</script>

<style scoped lang="scss">
.footer {
  text-align: center;
  padding: 2em 0;
  font-size: 11px;
  line-height: 1em;
  p {
    margin: 0 0.5em;
    display: inline;
  }
  a {
    margin: 0 0.5em;
    color: #e51c57;
    text-decoration: underline;
  }
}
.return_top {
  width: 50px;
  height: 50px;
  right: 10px;
  bottom: 10px;
  position: fixed;
  z-index: 90;
  @media print, screen and (max-width: 960px) {
    width: 30px;
    height: 30px;
    right: 5px;
    bottom: 5px;
  }
  a {
    border: 2px solid #000;
    background-color:  #fff;
    display: block;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  img {
    vertical-align: middle;
    @media print, screen and (max-width: 960px) {
      width: 10px;
    }
  }
}
</style>
